import React from 'react';

const Error404 = () => {
  const PUBLIC_URL = process.env.PUBLIC_URL;

  return (
    <div className="min-h-screen flex">
      {/* Left Panel - Branding */}
      <div
        className="hidden lg:flex lg:w-full relative overflow-hidden"
        style={{
          background: 'linear-gradient(135deg, #0f172a 0%, #1e3a2f 50%, #14532d 100%)',
        }}
      >
        {/* Decorative Elements */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-64 h-64 bg-emerald-500 rounded-full blur-3xl"/>
          <div className="absolute bottom-20 right-20 w-96 h-96 bg-blue-500 rounded-full blur-3xl"/>
        </div>

        <div className="relative mx-auto z-10 flex flex-col justify-center px-16 text-white">
          {/* Logo */}
          <div className="flex items-center gap-4 mb-12">
            <div
              className="w-16 h-16 rounded-2xl flex items-center justify-center shadow-lg"
              // style={{background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)'}}
            >
              <span className="text-2xl font-bold">
                <img src={`${PUBLIC_URL}/favicon.ico`} alt={"logo"}/>
              </span>
            </div>
            <div>
              <h1 className="text-3xl font-bold tracking-tight">GROUPE SURPLUS</h1>
              <p className="text-emerald-400 text-sm tracking-widest font-medium">RECYCLAGE</p>
            </div>
          </div>
          <h2 className="text-5xl font-bold mb-6 leading-tight">
            404
            <br/>
            <span className="text-emerald-400">Not Found</span>
          </h2>
          <p className="text-gray-300 text-lg max-w-md mb-10 leading-relaxed">
            Désolé ! La page que vous recherchez est introuvable. Elle a peut-être été déplacée ou supprimée.
          </p>
          <a
            href='/auth/login'
            className="text-emerald-600 hover:text-emerald-700 font-medium"
          >
            Revenir à la page de connexion
          </a>
        </div>
      </div>
    </div>
  );
};

export default Error404;
